import { render, staticRenderFns } from "./CollaspableSidebar.vue?vue&type=template&id=7f9b4f56"
import script from "./CollaspableSidebar.vue?vue&type=script&lang=js"
export * from "./CollaspableSidebar.vue?vue&type=script&lang=js"
import style0 from "./collaspable-sidebar.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports